import { render } from "./CarousselCTAItem.vue?vue&type=template&id=c8049cf0&scoped=true"
import script from "./CarousselCTAItem.vue?vue&type=script&lang=js"
export * from "./CarousselCTAItem.vue?vue&type=script&lang=js"

import "./CarousselCTAItem.vue?vue&type=style&index=0&id=c8049cf0&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\benja\\Desktop\\SKWinkelStarter\\Frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c8049cf0"]])

export default __exports__